import SelectComponent from "components/atoms/select/SelectComponent";
import type { CustomSelectProps } from "components/atoms/select/SelectComponent";
import styled from "styled-components";
import { Option, timeOptions } from "utils/options";
import TIME_ICON from "assets/icons/time.svg";
import * as mediaQuery from "components/MediaQuery";
import { useAppSelector } from "redux/hooks";

type OptionsType = Array<Option>;

export type TimeSelectProps = Omit<
  CustomSelectProps<string>,
  "options" | "value" | "defaultValue" | "onChange"
> & {
  options?: OptionsType;
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
};

export default function TimeSelect(props: TimeSelectProps) {
  const theme = useAppSelector((state) => state.theme.theme);
  const options = props.options ?? timeOptions;
  const value = props.value ?? options[0]?.value;

  return (
    <Wrapper>
      <SelectComponent
        {...props}
        className="time-select"
        options={options}
        value={value}
        defaultValue={props.defaultValue ?? options[0]?.value}
        placeholder={props.placeholder ?? "Select"}
        onChange={(v) => props.onChange?.(String(v))}
        suffixIcon={
          <Indicator disabled={props.disabled} $themeMode={theme}>
            <img src={TIME_ICON} alt="time icon" />
          </Indicator>
        }
        listHeight={300}
        showSearch={false}
        virtual={false}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  .ant-select-selector {
    min-height: unset !important;
    height: 35px !important;
    max-height: 35px !important;
  }
`;

const Indicator = styled.div<{ disabled?: boolean; $themeMode: string }>`
  padding: 5px;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.COLORS.DISABLED : theme.COLORS.BUTTONS2};
  border-radius: 4px;

  img {
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  }

  ${mediaQuery.isDefault} {
    height: max-content;
    img {
      width: 16px;
    }
  }

  ${mediaQuery.isMobile} {
    img {
      width: 14px;
    }
  }
`;
